export default "__VITE_ASSET__BdwV9xdv__"